import React, { useEffect, useRef } from 'react';
export var ScrollLock = function ScrollLock() {
  var documentRef = useRef();
  useEffect(function () {
    var document = documentRef.current.ownerDocument;
    var _document$body$style = document.body.style,
      paddingRight = _document$body$style.paddingRight,
      overflow = _document$body$style.overflow;
    document.body.style.paddingRight = "".concat(document.defaultView.innerWidth - document.documentElement.clientWidth, "px");
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = overflow;
      document.body.style.paddingRight = paddingRight;
    };
  }, []);
  return React.createElement("span", {
    hidden: true,
    ref: documentRef
  });
};